import { Badge, Text } from '@mantine/core'
import { isArray, isArrayLikeObject, isDate, isObject, isString } from 'lodash'
import React from 'react'

import { DateField } from '.'

type ValueObjectProps = { name: string; value: string; quantity?: number }

interface Props {
  value: Date | string | string[] | number | boolean | ValueObjectProps | ValueObjectProps[]
  type: string
}

export default function ComplementValue({ value, type }: Props) {
  const color = 'dimmed'
  const size = 'xs'

  switch (type) {
    case 'integer':
      return isString(value) || typeof value === 'number' ? (
        <Text color={color} size={size}>
          {String(value)}
        </Text>
      ) : null

    case 'text':
      return isString(value) ? (
        <Text color={color} size={size}>
          {value}
        </Text>
      ) : null

    case 'boolean': {
      const isTrue = value === 'true' || value === true
      return (
        <Badge size="xs" color={isTrue ? 'green' : 'gray'} variant="light">
          {isTrue ? 'Sim' : 'Não'}
        </Badge>
      )
    }

    case 'date':
      return isDate(value) || isString(value) ? (
        <Text color={color} size={size}>
          <DateField value={value} type="date" />
        </Text>
      ) : null

    case 'option':
      return isObject(value) && !isArray(value) && !isDate(value) ? (
        <Text color={color} size={size}>
          {(value as ValueObjectProps).name}
        </Text>
      ) : null

    case 'multioption':
      return isArrayLikeObject(value) ? (
        <>
          {(value as ValueObjectProps[]).map(({ name, value: optionValue, quantity }: any) => (
            <Text key={optionValue || name} color={color} size={size}>
              - {quantity && Number(quantity) > 1 ? `${quantity}x ` : ''}
              {name}
            </Text>
          ))}
        </>
      ) : null

    default:
      return value ? <Text color={color} size={size}>{String(value)}</Text> : null
  }
}
